import React from 'react';

export const LoadingState = ({ alignLeft, loadingClass }) => {
    return(
        <div className={"block fs-3" + (alignLeft ? " w-100 mt-2" : " text-center m-auto") + (loadingClass ? ` ${loadingClass}` : "")}>
            <div className="spinner-border spinner-border-sm text-primary mr-1" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <span className="align-middle text-dark o-70">Veuillez patienter...</span>
        </div>
    );
}